import React from 'react';

import { PATIENT_FORM_TEMPLATE_REQUIRED_QUESTION } from '../../constants';
import FiltersSelectContent from '../FiltersSelectContent';

interface FilterPatientFormTemplateQuestionRequiredProps {
  type?: string;
}

const FilterPatientFormTemplateQuestionRequired: React.FC<FilterPatientFormTemplateQuestionRequiredProps> = ({
  type = 'requiredQuestion',
}) => <FiltersSelectContent type={type} items={PATIENT_FORM_TEMPLATE_REQUIRED_QUESTION} />;
export default FilterPatientFormTemplateQuestionRequired;
